<template>
  <div class="col-sm-12">
    <br />
    <br />
    <h3>Reviewing the summary and finalizing records</h3>
    <table>
      <tbody>
        <tr>
          <td>
            <p class="NOTE">
              Once you upload a file you should see a simple table with totals in it. The totals represent what the system knows so far about your
              data. It should look something like this:
            </p>
          </td>
        </tr>
        <tr>
          <td>
            <table>
              <tbody>
                <tr>
                  <td colspan="3" class="note2">
                    Totals
                    <a class="text" href="/admin-points-faq/summary" target="_blank"></a>
                  </td>
                </tr>
                <tr>
                  <td>Action</td>
                  <td>Status</td>
                  <td>Total</td>
                </tr>

                <tr>
                  <td>edit</td>
                  <td>company not found</td>
                  <td>1</td>
                </tr>

                <tr>
                  <td>edit</td>
                  <td>missing Data</td>
                  <td>2</td>
                </tr>

                <tr>
                  <td>Insert</td>
                  <td>OK</td>
                  <td>2</td>
                </tr>

                <tr>
                  <td>Update</td>
                  <td>OK</td>
                  <td>505</td>
                </tr>
              </tbody>
            </table>
            <br />
            <br />
          </td>
        </tr>
        <tr>
          <td>
            <p class="note">
              If you see one any row with an "edit" action you should look for the
              <input type="button" value="edit records" class="btn btn-primary btn-lg btn-sm-block mr-2" />
              button. Click on it, make appropriate changes and update your records. When all the rows "action" column say "insert" (For new users) or
              "update" (for existing users) you are ready to finalize your changes.
            </p>
            <p class="note">Look for the</p>
            <div><input type="button" value="insert records" class="btn btn-primary btn-lg btn-sm-block mr-2" /></div>
            <br />
            button to finalize new users and look for the <br />
            <br />
            <div><input type="button" value="update records" class="btn btn-primary btn-lg btn-sm-block mr-2" /></div>
            <br />
            button to finalize updates. If something doesn't look quite right you may also "preview" the records you are about to update or insert. Be
            warned, if you are doing a great many records, previewing can take quite some time.
            <p></p>
          </td>
        </tr>
      </tbody>
    </table>
    <br />
    <br />
  </div>
</template>
<script>
export default {
  name: 'Summary',
};
</script>
<style scoped>
table {
  border: 0px solid transparent;
  font-size: 14px;
  width: inherit;
}
fieldset {
  padding: 0.35em 0.625em 0.75em;
  margin: 0 5px;
  border: 1px solid silver;
  border-radius: 8px;
}
legend {
  width: auto;
  padding: 10px;
  font-size: 15px;
  color: #333;
  border: 0;
  border-bottom: none;
}
</style>
